__webpack_require__.i.push((options) => {
	const originalFactory = options.factory;
	options.factory = function (moduleObject, moduleExports, webpackRequire) {
		__webpack_require__.$Refresh$.setup(options.id);
		try {
			originalFactory.call(this, moduleObject, moduleExports, webpackRequire);
		} finally {
			if (typeof Promise !== 'undefined' && moduleObject.exports instanceof Promise) {
				options.module.exports = options.module.exports.then(
					(result) => {
						__webpack_require__.$Refresh$.cleanup(options.id);
						return result;
					},
					(reason) => {
						__webpack_require__.$Refresh$.cleanup(options.id);
						return Promise.reject(reason);
					}
				);
			} else {
				__webpack_require__.$Refresh$.cleanup(options.id)
			}
		}
	};
})

__webpack_require__.$Refresh$ = {
	register: () => (undefined),
	signature: () => ((type) => (type)),
	runtime: {
		createSignatureFunctionForTransform: () => ((type) => (type)),
		register: () => (undefined)
	},
	setup: (currentModuleId) => {
		const prevModuleId = __webpack_require__.$Refresh$.moduleId;
		const prevRegister = __webpack_require__.$Refresh$.register;
		const prevSignature = __webpack_require__.$Refresh$.signature;
		const prevCleanup = __webpack_require__.$Refresh$.cleanup;

		__webpack_require__.$Refresh$.moduleId = currentModuleId;

		__webpack_require__.$Refresh$.register = (type, id) => {
			const typeId = currentModuleId + " " + id;
			__webpack_require__.$Refresh$.runtime.register(type, typeId);
		}

		__webpack_require__.$Refresh$.signature = () => (__webpack_require__.$Refresh$.runtime.createSignatureFunctionForTransform());

		__webpack_require__.$Refresh$.cleanup = (cleanupModuleId) => {
			if (currentModuleId === cleanupModuleId) {
				__webpack_require__.$Refresh$.moduleId = prevModuleId;
				__webpack_require__.$Refresh$.register = prevRegister;
				__webpack_require__.$Refresh$.signature = prevSignature;
				__webpack_require__.$Refresh$.cleanup = prevCleanup;
			}
		}
	}
};